import * as graphql from '@treams/treams-network';
import { Heading3, Paragraph, UnorderedList } from '@treams/treams-ui';

import { SharedFields } from '../ProductConfiguration';
import ProductLayout from '../ProductLayout';
import ProductTile from '../ProductTile';

function translate(key: string): { title: string; description: string } | undefined {
	if (key === 'authToken') {
		return {
			title: 'Auth token (toegangssleutel)',
			description:
				'Vul hier de auth token van Employes in. Je vindt deze in je Instellingen bij Employes.',
		};
	}

	if (key === 'administrationIDs') {
		return {
			title: 'Administrations',
			description: 'Administrations',
		};
	}

	if (key in SharedFields) {
		return SharedFields[key];
	}

	return {
		title: key,
		description: 'Nog niet geconfigureerd',
	};
}

function EmployesDescription() {
	return (
		<>
			<Paragraph mb={2}>
				Employes biedt ondernemers een laagdrempelige online oplossing voor salarisadministratie.
				Dat scheelt tijd en bespaart kosten.
			</Paragraph>
			<Paragraph mb={2}>
				De software is speciaal voor ondernemers. Daardoor is het geen ingewikkelde software, maar
				een makkelijk systeem.
			</Paragraph>
			<Paragraph mb={2}>
				<UnorderedList>
					<li>Direct van start</li>
					<li>Binnen een paar minuten verlonen</li>
					<li>Geen verborgen kosten</li>
					<li>Snelle klantenservice</li>
				</UnorderedList>
			</Paragraph>
			<Heading3 mb={1}>Hoe werkt het?</Heading3>
			<Paragraph mb={2}>
				Via een eenvoudig stappenplan kun je de verloning doen. Je geeft snel de gewerkte uren,
				verlof en vergoedingen door. Daarna kun je de werknemers betalen via een betaalbestand en
				verstuur je de loonstroken.
			</Paragraph>
			<Heading3 mb={1}>Wat biedt Employes?</Heading3>
			<Paragraph mb={2}>
				Employes is inclusief:
				<UnorderedList>
					<li>100% online salarisadministratie</li>
					<li>Alle salarisdocumenten (loonstroken, jaaropgave etc.)</li>
					<li>Verlof & verzuim</li>
					<li>Declaraties</li>
					<li>Digitaal ondertekenen</li>
					<li>Urenregistratie (voor oproepkrachten)</li>
					<li>Gratis overstapservice</li>
				</UnorderedList>
			</Paragraph>
		</>
	);
}

export default function Employes() {
	return (
		<ProductLayout
			id="employes"
			type={graphql.ConnectorType.Employes}
			description={<EmployesDescription />}
			headerImageURL="https://assets.ontreams.com/marketplace/employes-wide.png"
			translate={translate}
			pricingLink="https://employes.nl/tarieven/bedrijf-met-personeel/"
			documentationLink="https://treams.notion.site/Uitleg-Employes-integreren-met-Treams-5ea37337cf244f0fa1688b708b81a6ef"
		/>
	);
}

export function EmployesTile(props: { selected: boolean }) {
	return (
		<ProductTile
			id="employes"
			title="Employes"
			description="Je Salaris en HR zaken, simpel geregeld"
			logoImageURL="https://assets.ontreams.com/marketplace/employes.svg"
			selected={props.selected}
		/>
	);
}
